module.exports = __webpack_public_path__ + "img/ico_arrow.3f9ebc0a.svg";